import { render, staticRenderFns } from "./DontWait.vue?vue&type=template&id=f9c4d8d2&"
import script from "./DontWait.vue?vue&type=script&lang=js&"
export * from "./DontWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports